import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { Observable } from 'rxjs';
import { PackageService } from '@services/packages/package.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { TranslateService } from '@services/translate/translate.service';

@Component({
    selector: 'app-package-editor-ibextv',
    templateUrl: './package-editor-ibextv.component.html',
    styleUrls: ['./package-editor-ibextv.component.scss'],
    providers: [PackageService],
    standalone: false
})
export class PackageEditorIbextvComponent implements OnInit, OnDestroy {

  public packageId;
  public myPackage: Models.Package;

  public messages;

  @Input() onSave: Observable<any>;
  public submitRequest = false;
  public generalFieldNames = ['enabled', 'overlayColor', 'backgroundColor', 'textColor', 'customCss', 'autoplayInterval'];
  private subscription: any;

  constructor(private route: ActivatedRoute, private snackbar: SnackbarService, private packageService: PackageService, private ts: TranslateService) {
  }

  async ngOnInit() {
    this.messages = this.ts.get('system');
    this.packageId = this.route.snapshot.params['id'];
    this.subscription = this.onSave.subscribe(type => {
      if (type === 'ibextv-reload') {
        this.initPackage();
      } else if (type === 'ibextv') {
        this.save();
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  public async save() {
    this.myPackage = await this.packageService.update(this.myPackage._id, this.myPackage);
    this.submitRequest = false;
    this.snackbar.success(this.messages.general.savedChanges, 2000);
  }

  private async initPackage() {
    this.myPackage = await this.packageService.get(this.packageId);
    if (!this.myPackage.ibexTV) {
      this.myPackage.ibexTV = new Models.PackageIbexTV();
    }
  }
}
